/** This file is auto generated by convertSvgToJsx.ts */

import icon from './dnb/contacts'
export default icon
